var deleteCookie, getCookie, setCookie;

getCookie = function(c_name) {
  var ARRcookies, cookie, i, len, x, y;
  ARRcookies = document.cookie.split(";");
  for (i = 0, len = ARRcookies.length; i < len; i++) {
    cookie = ARRcookies[i];
    x = cookie.substr(0, cookie.indexOf("="));
    y = cookie.substr(cookie.indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x === c_name) {
      return unescape(y);
    }
  }
};

setCookie = function(c_name, value, exdays) {
  var c_value, exdate;
  exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  if (exdays != null) {
    c_value = escape(value) + "; expires=" + exdate.toUTCString();
  } else {
    c_value = escape(value);
  }
  return document.cookie = c_name + "=" + c_value;
};

deleteCookie = function(c_name) {
  return document.cookie = encodeURIComponent(c_name) + "=deleted; expires=" + new Date(0).toUTCString();
};

//# sourceMappingURL=maps/cookie.js.map
